<template>
  <div>
    <h5
      class="title is-5"
      :class="[
        isCollapsed ? 'mb-0' : '',
        collapsible ? 'title--collapsible-title' : '',
        smallText ? 'is-size-6' : ''
      ]"
      @click="toggle"
    >
      <i
        v-if="collapsible"
        class="fa collapse-icon"
        :class="isCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'"
      ></i>
      <span v-html="$t(title)"></span>
    </h5>
    <div v-show="!collapsible || !isCollapsed">
      <slot>
        <p v-safe-html="getContent"></p>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    contentList: {
      type: [Array, String, Object],
      default: () => []
    },
    collapsible: {
      type: Boolean,
      default: true
    },
    smallText: {
      type: Boolean,
      default: false
    },
    startCollapsed: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean,
      default: null
    },
    plainText: {
      type: Boolean,
      default: false
    }
  },
  emits: ["toggle"],
  data() {
    return {
      isCollapsed: this.open !== null ? !this.open : this.startCollapsed
    };
  },
  watch: {
    open(newVal) {
      if (newVal !== null) {
        this.isCollapsed = !newVal;
      }
    }
  },
  methods: {
    toggle() {
      if (!this.collapsible) return;
      this.isCollapsed = !this.isCollapsed;
      this.$emit("toggle", !this.isCollapsed);
    }
  },
  computed: {
    getContent() {
      if (!this.contentList) {
        console.log("not content found for", this.title);
        return "";
      }

      let contentItems = [];
      if (Array.isArray(this.contentList)) {
        contentItems = this.contentList;
      } else if (typeof this.contentList === "string") {
        contentItems = [this.contentList];
      } else if (typeof this.contentList === "object") {
        contentItems = Object.values(this.contentList);
      }

      const normalizedItems = contentItems
        .filter((item) => item !== null && item !== undefined)
        .map((item) => String(item).trim())
        .filter((item) => item.length > 0);

      if (!normalizedItems.length) {
        console.log("not content found for", this.title);
        return "";
      }

      // Extract individual <li> contents from items that contain <ul> markup,
      // so we can merge everything into a single flat list.
      const flatItems = [];
      normalizedItems.forEach((item) => {
        if (item.indexOf("<ul>") > -1) {
          const liMatches = item.match(/<li>([\s\S]*?)<\/li>/gi);
          if (liMatches) {
            liMatches.forEach((li) => {
              const inner = li.replace(/<\/?li>/gi, "").trim();
              if (inner.length > 0) {
                flatItems.push(inner);
              }
            });
          } else {
            flatItems.push(item);
          }
        } else {
          flatItems.push(item);
        }
      });

      if (!flatItems.length) {
        return "";
      }

      if (this.plainText) {
        return flatItems.join("<br />");
      }

      return `<ul class="mt-0"><li>${flatItems.join("</li><li>")}</li></ul>`;
    }
  }
};
</script>
